import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const SwitcherContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  /* Style for mobile menu context */
  .mobile-menu & {
    flex-direction: column; /* Stack buttons in mobile menu */
    width: 100%;
  }
`;

const LanguageButton = styled.button<{ $isActive: boolean }>`
  background: none;
  border: 1px solid
    ${(props) =>
      props.$isActive
        ? props.theme.colors.primary
        : props.theme.colors.borders};
  color: ${(props) =>
    props.$isActive
      ? props.theme.colors.primary
      : props.theme.colors.textSecondary};
  padding: 5px 10px;
  border-radius: ${(props) => props.theme.borderRadius};
  cursor: pointer;
  font-family: ${(props) => props.theme.fontFamilies.primary};
  font-weight: 500;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.primary};
  }

  .mobile-menu & {
    width: 80%; /* Make buttons wider in mobile menu */
    text-align: center;
  }
`;

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <SwitcherContainer>
      <LanguageButton
        onClick={() => changeLanguage('en')}
        $isActive={i18n.language === 'en'}
      >
        {t('languageSwitcher.english')}
      </LanguageButton>
      <LanguageButton
        onClick={() => changeLanguage('pa')}
        $isActive={i18n.language === 'pa' || i18n.language.startsWith('pa-')}
      >
        {t('languageSwitcher.punjabi')}
      </LanguageButton>
    </SwitcherContainer>
  );
};

export default LanguageSwitcher;
